import LayoutBody from "@/layout/layout-body";

export default [
  {
    path: "/",
    component: LayoutBody,
    children: [
      {
        path: "/participa",
        component: () => import("@/views/redVoluntariado/registro-voluntariado"),
      },
      {
        path: "/observa",
        component: () => import("@/views/redVoluntariado/registro-voluntariado"),
      },
    ],
  }
];
